import { styled } from "@mui/material/styles";
import TableCell from '@mui/material/TableCell';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    padding: "0px 8px", 
  }));

export default StyledTableCell;
